import React from 'react';
import { FaShoppingCart, FaGift, FaCoins } from 'react-icons/fa';
import styles from './AboutRewardPoints.module.css';

const AboutRewardPoints = () => {
    return (
        <section className={styles.rewardSection}>
            <div className={styles.headingContainer}>
                <h1 className={styles.heading}>
                    Earn <span className={styles.highlight}>Reward Points</span> with Every Purchase!
                </h1>
                <p className={styles.subHeading}>
                    Shop, earn points, and redeem them for your favorite items. It’s that simple!
                </p>
            </div>
            <div className={styles.stepsContainer}>
                <div className={styles.step}>
                    <FaShoppingCart className={styles.icon} />
                    <h3>Shop</h3>
                    <p>Make a purchase and earn points for every dollar spent.</p>
                </div>
                <div className={styles.step}>
                    <FaCoins className={styles.icon} />
                    <h3>Earn Points</h3>
                    <p>Points are automatically added to your account after each purchase.</p>
                </div>
                <div className={styles.step}>
                    <FaGift className={styles.icon} />
                    <h3>Redeem</h3>
                    <p>Use your points to buy desired items or enjoy exclusive discounts.</p>
                </div>
            </div>
        </section>
    );
};

export default AboutRewardPoints;
